import { render, staticRenderFns } from "./Fyc.vue?vue&type=template&id=6f2d1538"
import script from "./Fyc.vue?vue&type=script&lang=js"
export * from "./Fyc.vue?vue&type=script&lang=js"
import style0 from "./Fyc.vue?vue&type=style&index=0&id=6f2d1538&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports